<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">Assignees</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  text color="grey"
                    @click.prevent="addAssignee()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <v-layout column>

                <v-flex v-if="showMessage">

                    <div :class="{'dv-message':true,'errorMessage':errorMessage}"
                        >
                        {{ message }}
                    </div>

                </v-flex>

                <v-flex  v-if="viewAddAssignee">
                    <v-layout row>
                        <v-flex>
                            <v-text-field
                                v-model="newAssignee"
                                label="Enter new Assignee"
                                @keydown.enter="addNewAssignee()"
                            ></v-text-field>
                        </v-flex>
                        <v-flex shrink>
                            <v-btn dark x-small color="pink" fab @click="viewAddAssignee=false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-flex>

                    </v-layout>                    
                </v-flex>
                <v-flex>

                    <v-data-table
                        :headers="columns"
                        :items="assignees"
                        mobile-breakpoint="0"
                    >

                        <template v-slot:[`item.Action`]="{ item }">
                            <v-icon
                                small
                                @click="deleteAssigneeConfirm(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>

                    </v-data-table>                        

                </v-flex>

            </v-layout>


        </v-container>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'

import {mapState, mapActions} from 'vuex'

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw},
    data(){
        return {
            drawer:false,
            assignees:[],
            viewAddAssignee:false,
            detailMode:'update',
            activeEmployee:null,
            newAssignee:'',
            columns:[
                {text:'Assignee',value:'assignee'},
                {text:'Assignee ID',value:'assigneeID'},
                {text:'Department',value:'department'},
                {text:'HD Type',value:'hdType'},
                { value: "Action", text: "" }
            ],
            message:"",
            showMessage:false,
            errorMessage:false,

        }
    },
    computed:{
        ...mapState(['currentUser'])
    },
    methods:{
        ...mapActions([]),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            this.setAssignees()

        },
        setAssignees(){

            let assignees = []
            fb.assigneesCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(docs=>{

                docs.forEach(doc=>{
                    assignees.push({
                        ...doc.data(),
                        id:doc.id
                    })
                });

                this.assignees = [...assignees]
                this.$store.state.assignees  = [...assignees]
                console.log("this.assignees",this.assignees)
            })
            .catch(err=>{
                console.log(err)
            })
        },
        addAssignee(){
            this.viewAddAssignee = true
        },
        async addNewAssignee(){
            console.log("Add new assignee..")
            
            this.resetErrorMessage()

            if (this.newAssignee == ''){
                return
            }

            let b = await fb.assigneesCollection.where('assignee','==',this.newAssignee).get()
            user = null
            for(const doc of b.docs){
                user = doc.data();
            }

            console.log("user",user)
            if (user){
                this.errorMessage = false
                this.message = "The user is already an assignee!"
                this.showMessage = true
                return
            }

            b = await fb.usersCollection.where('email','==',this.newAssignee).get()
            let user = null
            for(const doc of b.docs){
                user = doc.data();
                user.id = doc.id
            }

            console.log("user",user)
            if (!user){
                this.errorMessage = false
                this.message = "The user does not exist!"
                this.showMessage = true
                return
            }
            

            console.log("Create here!")

            b = await fb.assigneesCollection.add({
                assignee:user.email,
                assigneeID:user.userID,
                hdType:this.currentUser.hdType,
                department:user.department,
            })

            console.log("b",b)
            console.log("user.id",user.id)
            if (b){
                await fb.usersCollection.doc(user.id).update({
                    userType:"assignee"
                })
                this.setAssignees()
            }

            this.viewAddAssignee  = false
        },
        deleteAssigneeConfirm(item){
            console.log('to delete',item)
            this.$confirm('Are you sure you want to delete this assignee?')
            .then(res=>{
                if (res){
                    fb.assigneesCollection.doc(item.id).delete();
                    //console.log("item.assigneeID",item.assigneeID)
                    fb.usersCollection.doc(item.assigneeID).update({
                        userType:"client"
                    })
            
                    this.assignees.splice(this.assignees.indexOf(item),1)
                }
            })
        },
        resetErrorMessage(){
            this.message = "";
            this.errorMessage = false;
            this.showMessage = false;
        },

        signOut(){

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },


    },
    mounted(){

        console.log("Assignees mounted!");


    },
    created(){
        console.log("Assignees Created")
        this.setAssignees()


    },

}
</script>

<style  scoped>

.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}

.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

</style>